<div class="aa-container">
  <app-title-container>
    <h1>Assessments</h1>
    <div right>
      <button mat-flat-button (click)="addNewAssessment()"><mat-icon>add</mat-icon> New Assessment</button>
    </div>
  </app-title-container>

  <app-all-assessments-filter></app-all-assessments-filter>

  <app-divider height="2px"></app-divider>
  @if (isLoading()()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="second-actions-container">
    <button
      class="clickable-text-btn ml-auto"
      (click)="exportExcel()"
      aria-label="Export to Excel"
      matTooltip="Please specify correct date range for the export filters. Allowed maximum is 13 months."
      [matTooltipDisabled]="!hasInvalidExportFilters()"
      [disabled]="isLoadingExport() || hasInvalidExportFilters()"
    >
      @if (isLoadingExport()) {
        <mat-icon class="clickable-text-btn-icon"><mat-spinner diameter="15"></mat-spinner></mat-icon>
      } @else {
        <mat-icon fontSet="material-symbols-outlined" class="clickable-text-btn-icon"> file_export </mat-icon>
      }

      Export to Excel
    </button>
  </div>

  <div class="table-container">
    <app-all-assessments-table></app-all-assessments-table>
  </div>
</div>
